import { InvestmentManagerV2 } from "@/utils/api-client";
import { ApiClientFactory } from "./clients";

export class InvestmentManagerV2Factory {
  private readonly apiClientFactory: ApiClientFactory;

  constructor(baseUrl: string) {
    this.apiClientFactory = new ApiClientFactory(
      `${baseUrl}/api/v2/investment`
    );
  }

  createInvestmentManagerV2(authToken: string): InvestmentManagerV2 {
    return new InvestmentManagerV2(
      this.apiClientFactory.createAuthorizedApiClient(authToken)
    );
  }
}
